/**
 * Zustand store for the AdminTargetsPage inline-edit form state.
 *
 * Per PATTERNS.md "useCroTargetsStore.ts" — mirrors useFilterStore.ts shape
 * (packages/spa/src/store/useFilterStore.ts) but without persistence: target
 * edits are transient UI state that should reset on page reload.
 *
 * State machine:
 *   - editingMetricId: which row is being edited (null = none)
 *   - editingValue: the <input type="number"> controlled value (string until
 *     parsed on save — avoids parseInt/parseFloat on every keystroke)
 *
 * The store intentionally holds only ONE row open at a time. A new setEditing()
 * call replaces the previous editing state (auto-cancel prior unsaved edit).
 */
import { create } from 'zustand';

export interface CroTargetsState {
  editingMetricId: string | null;
  editingValue: string;          // controlled input — string until parsed on save
  setEditing: (metricId: string, currentValue: number) => void;
  updateValue: (s: string) => void;
  cancelEdit: () => void;
}

export const useCroTargetsStore = create<CroTargetsState>((set) => ({
  editingMetricId: null,
  editingValue: '',
  setEditing: (metricId, currentValue) =>
    { set({ editingMetricId: metricId, editingValue: String(currentValue) }); },
  updateValue: (s) => { set({ editingValue: s }); },
  cancelEdit: () => { set({ editingMetricId: null, editingValue: '' }); },
}));
